import React, { useState } from 'react';
import IconInput from '../../../components/IconInput/IconInput';
import RadioModal from '../../../components/RadioModal/RadioModal';
import arrowDown from 'src/assets/arrowDown.png';

export const ELD_VENDORS = [
  { label: 'Omnitracs' },
  { label: 'Samsara' },
  { label: 'KeepTruckin' },
  { label: 'Geotab' },
  { label: 'Verizon Connect' },
  { label: 'Other' },
  { label: 'None' },
];

export const ELD_DATA_SHARING_OPTIONS = [
  { label: 'ELD & Dash Cam' },
  { label: 'ELD Only' },
  { label: 'None' },
];

/** Maps display labels to backend enum values */
export const eldVendorValueMap: Record<string, string> = {
  Omnitracs: 'OMNITRACS',
  Samsara: 'SAMSARA',
  KeepTruckin: 'KEEPTRUCKIN',
  Geotab: 'GEOTAB',
  'Verizon Connect': 'VERIZON_CONNECT',
  Other: 'OTHER',
  None: 'NONE',
};

export const eldDataSharingValueMap: Record<string, string> = {
  'ELD & Dash Cam': 'dash_cam',
  'ELD Only': 'eld_only',
  None: 'none',
};

/** Reverse maps for populating from backend values */
export const eldVendorLabelMap: Record<string, string> = Object.fromEntries(
  Object.entries(eldVendorValueMap).map(([k, v]) => [v, k]),
);

export const eldDataSharingLabelMap: Record<string, string> = Object.fromEntries(
  Object.entries(eldDataSharingValueMap).map(([k, v]) => [v, k]),
);

interface EldSectionProps {
  eld: {
    vendor: string;
    setVendor: (value: string) => void;
    dataSharingOption: string;
    setDataSharingOption: (value: string) => void;
  };
}

const EldSection: React.FC<EldSectionProps> = ({ eld }) => {
  const [isVendorModalVisible, setVendorModalVisible] = useState(false);
  const [isDataSharingModalVisible, setDataSharingModalVisible] = useState(false);

  const vendorDisplayLabel = eldVendorLabelMap[eld.vendor] || '';
  const dataSharingDisplayLabel = eldDataSharingLabelMap[eld.dataSharingOption] || '';

  const handleVendorSelect = (label: string) => {
    eld.setVendor(eldVendorValueMap[label] || label);
  };

  const handleDataSharingSelect = (label: string) => {
    eld.setDataSharingOption(eldDataSharingValueMap[label] || label);
  };

  return (
    <>
      <IconInput
        testID={'insurance-policy-eld-vendor'}
        label="ELD Provider"
        value={vendorDisplayLabel}
        placeholder="Select ELD Provider"
        iconSource={arrowDown}
        iconWidth={20}
        iconHeight={20}
        onPress={() => setVendorModalVisible(true)}
        onIconPress={() => setVendorModalVisible(true)}
      />
      <RadioModal
        testID={'eld-vendor-modal'}
        isVisible={isVendorModalVisible}
        onClose={() => setVendorModalVisible(false)}
        title="Select ELD Provider"
        options={ELD_VENDORS}
        onSelectOption={handleVendorSelect}
        onButtonClickLeft={() => setVendorModalVisible(false)}
        selectedValue={vendorDisplayLabel}
      />

      <IconInput
        testID={'insurance-policy-eld-data-sharing'}
        label="ELD Data Sharing"
        value={dataSharingDisplayLabel}
        placeholder="Select Data Sharing Option"
        iconSource={arrowDown}
        iconWidth={20}
        iconHeight={20}
        onPress={() => setDataSharingModalVisible(true)}
        onIconPress={() => setDataSharingModalVisible(true)}
      />
      <RadioModal
        testID={'eld-data-sharing-modal'}
        isVisible={isDataSharingModalVisible}
        onClose={() => setDataSharingModalVisible(false)}
        title="ELD Data Sharing"
        options={ELD_DATA_SHARING_OPTIONS}
        onSelectOption={handleDataSharingSelect}
        onButtonClickLeft={() => setDataSharingModalVisible(false)}
        selectedValue={dataSharingDisplayLabel}
      />
    </>
  );
};

export default EldSection;
